import { FORM } from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';

export default function formGroupAttributAdd(){

    var obj = {
        titleForm: "Ajouter un modèle",
        subTitleForm: "Veuillez compléter les champs ci-dessous pour créer votre modèle",
        langSelect: true,
        drawerType: 'swipeable',
        noForm: true,
        component: Button,
        formConfig: {
            type: FORM,
            children: [
                {
                    optionsInputs: [
                        {
                            type: 'text',
                            label: 'Libellé',
                            helper: {
                                text: 'Libellé du modèle',
                                link: false,
                            },
                            required: false,
                            stateName: 'groupName',
                            translated: true
                        },
                        {
                            type: 'text',
                            label: 'Identifiant',
                            helper: {
                                text: 'Identifiant du modèle',
                                link: false,
                            },
                            required: true,
                            stateName: 'groupIdentifier',
                            translated: false
                        },
                    ]
                },
            ]
        }
    }
    return obj;
}